var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row page-title mb-5 mt-5 pb-5 pt-5"},[_c('div',{staticClass:"col-12 offset-1"},[_c('h1',{},[_vm._v("Maintenance!")])])]),_c('div',{staticClass:"page-content row"},[_c('div',{staticClass:"col-12 col-lg-8 offset-lg-4"},[_c('p',[_c('b',[_vm._v("Heroes")]),_vm._v(", the site is under maintenance. ")])])])])
}]

export { render, staticRenderFns }